import { VTC_SECONDARY_GREEN } from '@swegon-core/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
    background-color: ${props => (props.isDraggingOver ? `${VTC_SECONDARY_GREEN}` : 'white')};
`;
